"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeCSSLifecycles = exports.createSingleSpaCssLifecycles = exports.singleSpaCssLifecycles = void 0;
/* For a module at http://localhost:8080/dist/js/main.js,
 * this will set the webpack public path to be
 * http://localhost:8080/dist/js/
 */
require("systemjs-webpack-interop/auto-public-path");
const single_spa_css_1 = __importDefault(require("single-spa-css"));
const baseConfig = {
    cssUrls: [],
    webpackExtractedCss: true
};
exports.singleSpaCssLifecycles = (0, single_spa_css_1.default)(baseConfig);
function createSingleSpaCssLifecycles(config = {}) {
    return (0, single_spa_css_1.default)({ ...baseConfig, ...config });
}
exports.createSingleSpaCssLifecycles = createSingleSpaCssLifecycles;
var utils_1 = require("./utils");
Object.defineProperty(exports, "mergeCSSLifecycles", { enumerable: true, get: function () { return utils_1.mergeCSSLifecycles; } });
